[
  {
    "id":"pbm_order_id",
    "value":"Order Id",
    "enable": true,
    "width": "60px"
  },
  {
    "id":"route_name",
    "value":"Route",
    "enable": true,
    "width": "57px"
  },
  {
    "id":"stop_sequence",
    "value":"Stop",
    "enable": true,
    "width": "45px"
  },
  {
    "id":"task_sequence",
    "value":"Task",
    "enable": true,
    "width": "44px"
  },
  {
    "id":"task_point_name",
    "value":"Task Point Name",
    "enable": true,
    "width": "96px"
  },
  {
    "id":"address",
    "value":"Address",
    "enable": true,
    "width": "59px"
  },
  {
    "id":"postal_code",
    "value":"Postal Code",
    "enable": true,
    "width": "74px"
  },
  {
    "id":"delivery_point_area_name",
    "value":"DLA",
    "enable": true,
    "width": "44px"
  },
  {
    "id":"item_count",
    "value":"Items",
    "enable": true,
    "width": "50px"
  },
  {
    "id":"goods_count",
    "value":"Goods",
    "enable": true,
    "width": "53px"
  },
  {
    "id":"task_type",
    "value":"Type",
    "enable": true,
    "width": "45px"
  },
  {
    "id":"source",
    "value":"Source",
    "enable": true,
    "width": "53px"
  },
  {
    "id":"initial_eta",
    "value":"IETA",
    "enable": true,
    "width": "45px"
  },
  {
    "id":"eta",
    "value":"RETA",
    "enable": true,
    "width": "48px"
  },
  {
    "id":"ata",
    "value":"ATA",
    "enable": true,
    "width": "46px"
  },
  {
    "id":"task_time_window",
    "value":"Time Window",
    "enable": true,
    "width": "66px"
  },
  {
    "id":"task_state",
    "value":"Status",
    "enable": true,
    "width": "46px"
  },
  {
    "id":"bl_name",
    "value":"BLOM Location",
    "enable": true,
    "width": "90px"
  },
  {
    "id":"reason_code",
    "value":"Reason Code",
    "enable": true,
    "width": "81px"
  },
  {
    "id":"driver_instruction",
    "value":"Driver Note",
    "enable": true,
    "width": "100px"
  },
  {
    "id":"manager_instruction",
    "value":"Manager Note",
    "enable": true,
    "width": "111px"
  },
  {
    "id":"vehicle_type",
    "value":"Vehicle Type",
    "enable": true,
    "width": "82px"
  },
  {
    "id":"consignee_name",
    "value":"Consignee Name",
    "enable": true,
    "width": "99px"
  },
  {
    "id":"user_name",
    "value":"User Information",
    "enable": true,
    "width": "99px"
  },
  {
    "id":"item_state",
    "value":"Item State",
    "enable": true,
    "width": "66px"
  },
  {
    "id":"weight",
    "value":"Weight",
    "enable": true,
    "width": "55px"
  },
  {
    "id":"volume",
    "value":"Volume",
    "enable": true,
    "width": "58px"
  },
  {
    "id":"outside_sp_perimeter",
    "value":"Perimeter",
    "enable": true,
    "width": "68px"
  },
  {
    "id":"quantity",
    "value":"Quantity",
    "enable": true,
    "width": "50px"
  },
  {
    "id":"pn_item_id",
    "value":"Barcode",
    "enable": true,
    "width": "50px"
  },
  {
    "id":"product_codes",
    "value":"Product Codes",
    "enable": true,
    "width": "68px"
  }
]